export enum AvatarShape {
    CIRCLE, RECT, HEXAGON
}
